export default "skymp5-front/293db3d76ab19fe8228fec890f8054c0.svg";